import React from "react";
import Helmet from "react-helmet";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const TitleComponent = ({ title }) => {
  var defaultTitle = "SW Prayer| Experience a New Media Culture";
  const location = useLocation();
  let path = location.pathname;
  let page = path;
  if (path === "/") {
    page = "home";
  }


  const seoData = useSelector((state) => state.seo);
  let meta = seoData?.seoData?.find((o) => o.page === page);
  return (
    <Helmet>
      <title>
        {meta?.seoDetails?.title[0] ? meta?.seoDetails?.title[0] : defaultTitle}
      </title>
      <description>
        {meta?.seoDetails?.description[0]
          ? meta?.seoDetails?.description[0]
          : defaultTitle}
      </description>
    </Helmet>
  );
};

export { TitleComponent };
